import { notificationKeys } from '@taler/api-client'
import { useQuery } from '@tanstack/vue-query'
import { computed, type ComputedRef } from 'vue'
import { useApi } from '@/app/api'

/** Beyond this many unread, the badge shows "N+" instead of an exact count. */
export const UNREAD_BADGE_CAP = 99
const REFRESH_INTERVAL_MS = 60_000

export interface UseUnreadCount {
  readonly count: ComputedRef<number>
  readonly atCap: ComputedRef<boolean>
  refresh(): void
}

export function useUnreadCount(): UseUnreadCount {
  const api = useApi()

  const query = useQuery({
    queryKey: notificationKeys.unreadCount(),
    queryFn: ({ signal }) => api.notifications.unreadCount(signal),
    refetchInterval: REFRESH_INTERVAL_MS,
    retry: false,
  })

  return {
    count: computed(() => Math.min(query.data.value ?? 0, UNREAD_BADGE_CAP)),
    atCap: computed(() => (query.data.value ?? 0) > UNREAD_BADGE_CAP),
    refresh: () => {
      void query.refetch()
    },
  }
}
